<section class="menu">
  <div class="menu--content">
    <header class="header">
      <button
        type="button"
        class="header--btnContainer"
        [routerLink]="['/landing']"
      >
        <img
          src="../../../assets/icons/arrow_back.svg"
          alt="Ir a mis vehículos"
        />
        <p class="header--btnContainer__text">
          {{ 'btnHome' | i18next | uppercase }}
        </p>
      </button>
      <h1 class="header--title">{{ 'menuTitle' | i18next }}</h1>
    </header>
    <main class="main">
      <div class="main--container">
        <app-card [data]="requestTypes" type="menu"> </app-card>
      </div>
    </main>
  </div>
</section>
